import { NavLink, Outlet, useLocation, Navigate } from "react-router-dom";
import { SECTION_PERMISSIONS } from "@/config/permissions";
import { usePermissions } from "@/features/auth/usePermissions";

const tabs = [
    { label: "All Logs", path: "/audit-logs/logs", permissions: SECTION_PERMISSIONS.AUDIT },
    {
        label: "Security",
        path: "/audit-logs/security",
        permissions: SECTION_PERMISSIONS.AUDIT_SECURITY,
    },
    {
        label: "Statistics",
        path: "/audit-logs/statistics",
        permissions: SECTION_PERMISSIONS.AUDIT,
    },
    {
        label: "My Actions",
        path: "/audit-logs/my-actions",
        permissions: SECTION_PERMISSIONS.AUDIT,
    },
];

export const AuditLogsLayout = () => {
    const { pathname } = useLocation();
    const { hasAnyPermission } = usePermissions();
    const visibleTabs = tabs.filter((tab) => hasAnyPermission(tab.permissions));
    const firstVisibleTab = visibleTabs[0]?.path ?? "/audit-logs/logs";

    if (pathname === "/audit-logs" || pathname === "/audit-logs/") {
        return <Navigate to={firstVisibleTab} replace />;
    }

    return (
        <div className="space-y-6">
            <div>
                <h1 className="text-2xl font-bold text-slate-900 dark:text-white">
                    Audit & Logs
                </h1>
                <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                    Track admin actions, review security events, and export compliance reports
                </p>
            </div>

            <div className="border-b border-slate-200 dark:border-slate-700">
                <nav className="-mb-px flex gap-6 overflow-x-auto">
                    {visibleTabs.map((tab) => (
                        <NavLink
                            key={tab.path}
                            to={tab.path}
                            className={({ isActive }) =>
                                `whitespace-nowrap border-b-2 px-1 pb-3 text-sm font-medium transition-colors ${isActive
                                    ? "border-primary-600 text-primary-600 dark:border-primary-400 dark:text-primary-400"
                                    : "border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"
                                }`
                            }
                        >
                            {tab.label}
                        </NavLink>
                    ))}
                </nav>
            </div>

            <Outlet />
        </div>
    );
};
